import styled, { css } from 'styled-components'
import { isNumber } from '@mote/helpers'

function evaluateValue(value) {
  return isNumber(value) ? `${value}px` : value
}

export const Block = styled.div`
  display: flex;
  flex-direction: ${({ layout }) => {
    switch (layout) {
      case 'horizontal':
        return 'row'
      case 'horizontal-reverse':
        return 'row-reverse'
      case 'vertical-reverse':
        return 'column-reverse'
      case 'vertical':
      default:
        return 'column'
    }
  }};
  justify-content: ${({ justify }) => (justify ? justify : 'initial')};
  align-items: ${({ align }) => (align ? align : 'initial')};

  ${({ gap }) =>
    gap &&
    css`
      gap: ${evaluateValue(gap)};
    `};

  ${({ zeroMinWidth }) =>
    zeroMinWidth &&
    css`
      min-width: 0;
    `};

  ${({ zeroMinHeight }) =>
    zeroMinHeight &&
    css`
      min-height: 0;
    `};

  ${({ wrapped }) =>
    wrapped &&
    css`
      flex-wrap: wrap;
    `};

  ${({ spreadX }) =>
    spreadX &&
    css`
      width: 100%;
    `};

  ${({ spreadY }) =>
    spreadY &&
    css`
      height: 100%;
    `};

  ${({ grow }) =>
    grow &&
    css`
      flex: 0 0 auto;
    `};

  ${({ width, spreadX }) =>
    !spreadX &&
    width &&
    css`
      width: ${evaluateValue(width)};
    `};

  ${({ height, spreadY }) =>
    !spreadY &&
    height &&
    css`
      height: ${evaluateValue(height)};
    `};

  ${({ minWidth, zeroMinWidth }) =>
    !zeroMinWidth &&
    minWidth &&
    css`
      min-width: ${evaluateValue(minWidth)};
    `};

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${evaluateValue(maxWidth)};
    `};

  ${({ minHeight, zeroMinHeight }) =>
    !zeroMinHeight &&
    minHeight &&
    css`
      min-height: ${evaluateValue(minHeight)};
    `};

  ${({ maxHeight }) =>
    maxHeight &&
    css`
      max-height: ${evaluateValue(maxHeight)};
    `};

  ${({ margin }) =>
    margin &&
    css`
      margin: ${evaluateValue(margin)};
    `};

  ${({ padding }) =>
    padding &&
    css`
      padding: ${evaluateValue(padding)};
    `};
`

export const BlockGroup = styled(Block)``
